import React from 'react';
import classNames from 'classnames';

const Loading = ({ fixed = false }) => {
    return <div className={classNames('qase-loading', { fixed })}></div>;
};

export default Loading;
